import { h, Component } from 'preact';
import Portal from 'preact-portal';

export interface HopplerModalProps {
  close?: Function;
  containerId?: string;
  isOutsideClickClose?: boolean;
}

export abstract class HopplerModal<P, S> extends Component<P, S> {
  refNode: any;

  componentDidMount() {
    
    if (this.props['isOutsideClickClose'] && this.props['containerId']) {
      let container = document.getElementById(this.props['containerId']);
      container.addEventListener('mousedown', this.onOutsideClick, false);
    }
    
  }

  onOutsideClick = (ev) => {
    const target = ev.target;

    if (target !== this.refNode) {
      // The reason for doing this instead of doing an outright this.props['close']()
      // is because we might need the close function to return something.
      // this help wrap aroud and the close function is called right;
      this.doModalClose();
    }
  }

  modalize(elem: JSX.Element) {
    return (
      <Portal into="body">
        <div className="hi-modal-container" id="hi-modal-111">
          { elem }
        </div>
      </Portal>
    )
  }
  
  abstract doModalClose();
}